import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import Logo from '../components/Logo';

const NotFound = () => (
  <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center" data-testid="not-found-page">
    <Seo title="Sida finst ikkje | Refuel Weekend" description="Denne sida finst ikkje på Refuel Weekend si nettside." path="/404" noindex />
    <Logo size="md" />
    <h1 className="mt-10 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "'Oktah Round', sans-serif" }}>404 – fann ikkje sida</h1>
    <p className="text-white/60 mt-3 max-w-md">Sida du leita etter finst ikkje. Gå tilbake til framsida for program, talarar og aktivitetar.</p>
    <Link to="/" data-testid="not-found-home-link" className="mt-8 px-8 py-3.5 rounded-full bg-[#ff2e2e] text-black font-bold uppercase tracking-wide hover:bg-[#ff4d4d] transition-colors">Til framsida</Link>
  </div>
);

export default NotFound;
